import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { SvgShapeDropdown } from "@routes/IconeSvg";

export default function Dropdown(props) {
  const { t } = useTranslation("components.dropdown.dropdown");
  const [fadeIn, setfadeIn] = useState(false);
  const showOptionList = () => {
    setfadeIn(!fadeIn);
  };
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: props.customStyleProps?.borderBottom || "none", // previous value : "2px solid F9FAFC"
      fontSize: "13px",
      color: state.isSelected
        ? props.customStyleProps?.colorSelected || "#73C7B7"
        : props.customStyleProps?.colorNoSelected || "black",
      backgroundColor: state.isSelected
        ? props.customStyleProps?.backgroundColorSelected ||
        "rgba(115, 199, 183, 0.1)"
        : props.customStyleProps?.backgroundColorNoSelected || "white",
    }),
    menu: (base) => ({
      ...base,
      ...props.customStyleMenu,
    }),
    // control: () => ({
    //   backgroundColor:  props.customStyleProps?.backgroundColorTriages || ,
    // }),
    ...props.customStyleProps,
  };

  useEffect(() => {
    if(props.isScrolled) {
      setfadeIn(false);
    }
  }, [props.isScrolled])
  
  return (
      <div
        className="arh-relative"
        onClick={showOptionList}
        onBlur={() => {
          setfadeIn(false);
        }}
      >
        <div
          className={
            props.isDisabled
              ? "arh-flex arh-items-center arh-h-full arh-absolute arh-right-[1rem] arh-top-[50%] -arh-translate-y-1/2 arh-z-[1] arh-pointer-events-none shapeNo_open "
              : fadeIn
                ? "arh-flex arh-items-center arh-h-full arh-absolute arh-right-[1rem] arh-top-[50%] -arh-translate-y-1/2 arh-z-[1] arh-pointer-events-none shape_Open "
                : "arh-flex arh-items-center arh-h-full arh-absolute arh-right-[1rem] arh-top-[50%] -arh-translate-y-1/2 arh-z-[1] arh-pointer-events-none shapeNo_open "
          }
        >
          {SvgShapeDropdown()}
        </div>
        <Select
          className={`arh-whitespace-pre-wrap arh-break-all arh-font-poppins arh-font-normal arh-text-xs arh-text-darkColor custom-select-container ${props.additionClass} ${props.validateDropdown || props.desactivated ? "custom-select-container--invalid" : ""}`}
          ref={props.refSelect}
          styles={customStyles}
          value={props.defaultValue}
          // isSearchable={true}
          onChange={props.handleChange}
          name={props.name}
          options={props.optionsList}
          placeholder={props.defaultText}
          noOptionsMessage={() => t("Aucun élément")}
          getOptionLabel={props.label}
          getOptionValue={props.value}
          isDisabled={props.isDisabled}
          isSearchable={props.isSearchable}
          onBlur={props.onBlur}
          menuIsOpen={fadeIn}
        />
      </div>
  );
}
